<!-- <Nav title="订单详情" /> -->
<template>
  	<van-nav-bar :title="title" left-arrow @click-left="backFn" class="top_bar" />	
</template>

<script>
export default {
	props: {
		title: String
	},
	data() {
		return {
			
		}
	},
	methods: {
		backFn() {
			this.$router.go(-1)
		},
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/components/Nav.vue